import { RouteAuthenticationRequirement, RouteItem } from '@invara-dev/react-base';
import { AppRoles } from '../../../constants/appRoles';
import { ApplicationRoutes } from '../../../constants/appRoutes';
import { Layout } from '../../../components/layout/layout';

export const v2InvoicingRoles = [AppRoles.BetaUser];
export const v2InvoiceCreationRoles = v2InvoicingRoles;

const createInvoicingShellRoute = (text: string, path: string): RouteItem => ({
  text,
  path,
  authenticationRequirement: RouteAuthenticationRequirement.Authenticated,
  allowedRoles: v2InvoiceCreationRoles,
  layout: <Layout />,
  async lazy() {
    const component = await import('./InvoicingShellPage');
    return { Component: component.default };
  }
});

export const V2InvoiceCreateRouteItem = createInvoicingShellRoute(
  'Create Invoice (V2)',
  ApplicationRoutes.invoicing.v2Create
);

export const V2InvoicingHiddenRoutes: RouteItem[] = [
  createInvoicingShellRoute('Invoicing', ApplicationRoutes.invoicing.shell)
];
